import axiosInstance from "../Context/axiosInstance";

export const fetchStudentFolderContents = async (userId, folderId, params, signal) => {
  if (!userId) throw new Error("Please sign in again to browse courses.");

  const { data: student } = await axiosInstance.get(`/users/${userId}`, { signal });
  const academicLevelId = Number(student.academicLevelId);
  if (!Number.isSafeInteger(academicLevelId) || academicLevelId <= 0) {
    throw new Error("Please set your academic level in your profile to browse courses.");
  }

  return axiosInstance.get(`/folders/${folderId}/contents`, {
    params: { ...params, academicLevelId },
    signal,
  });
};
